import axiosInstance from './axiosInstance';

export async function getDispatchers(page = 1, limit = 10) {
  const response = await axiosInstance.get('/dispatchers/get-dispatchers.php', {
    params: { page, limit },
  });
  return response.data;
}

export async function createDispatcher(dispatcherData) {
  const response = await axiosInstance.post('/dispatchers/create-dispatcher.php', dispatcherData);
  return response.data;
}

export async function getDispatcherDetail(id) {
  const response = await axiosInstance.get(`/dispatchers/get-dispatcher-detail.php?id=${id}`);
  return response.data;
}

export async function editDispatcher(dispatcherData) {
  const response = await axiosInstance.post('/dispatchers/edit-dispatcher.php', dispatcherData);
  return response.data;
}



export async function deactivateDispatcher(id, isActive) {
  const response = await axiosInstance.post('/dispatchers/deactivate-dispatcher.php', {
    id_dispatcher: id,
    is_active: isActive,
  });
  return response.data;
}